export class TopScroller {
    constructor(selector, duration) {
        this.elements = document.querySelectorAll(selector);
        this.duration = duration;
        this.startTimestamp = null;
    }

    init() {
        this.elements.forEach((element) => {
            element.addEventListener('click', () => this.handleScroll());
        });
    }

    handleScroll() {
        const startPosition = window.pageYOffset;
        const targetPosition = 0;
        const distance = targetPosition - startPosition;

        const scrollAnimation = (timestamp) => {
            if (!this.startTimestamp) this.startTimestamp = timestamp;
            const progress = timestamp - this.startTimestamp;
            const scrollY = this.easeInOutQuad(progress, startPosition, distance, this.duration);
            window.scrollTo(0, scrollY);

            if (progress < this.duration) {
                window.requestAnimationFrame(scrollAnimation);
            } else {
                this.startTimestamp = null; // Reset startTimestamp after scroll animation completes
            }
        };

        window.requestAnimationFrame(scrollAnimation);
    }

    easeInOutQuad(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
    }
}
